module.exports = __webpack_public_path__ + "static/media/TASK 1.d860be30.mp3";